import React, { useRef, useImperativeHandle } from 'react';
import PropTypes from '@userzoomlibraries/toolkit-js-utils/prop-types';
import useAriaAttributes from '@userzoomlibraries/toolkit-react-utils/use-aria-attributes';
import useDataAttributes from '@userzoomlibraries/toolkit-react-utils/use-data-attributes';
import { jsx } from 'react/jsx-runtime';

var _excluded = ["children", "disabled", "label"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var NativeSelectOptionGroup = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
      disabled = _ref.disabled,
      label = _ref.label,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  var ariaAttributes = useAriaAttributes(otherProps);
  var dataAttributes = useDataAttributes(otherProps);
  var nativeSelectOptionGroupRef = useRef();
  useImperativeHandle(ref, function () {
    return nativeSelectOptionGroupRef.current;
  });
  return /*#__PURE__*/jsx("optgroup", _objectSpread(_objectSpread(_objectSpread({
    ref: nativeSelectOptionGroupRef,
    className: "gz-native-select__option-group",
    disabled: disabled,
    label: label // eslint-disable-next-line react/jsx-props-no-spreading

  }, ariaAttributes), dataAttributes), {}, {
    children: children
  }));
});
NativeSelectOptionGroup.COMPONENT_ID = 'Gearz.NativeSelect.OptionGroup';
NativeSelectOptionGroup.displayName = NativeSelectOptionGroup.COMPONENT_ID;
NativeSelectOptionGroup.propTypes = {
  children: PropTypes.nodeWithDescription('Content of the option group.'),
  disabled: PropTypes.boolWithDescription('Flag to make the option group disable.'),
  label: PropTypes.stringWithDescription('Label of the option group.')
};
NativeSelectOptionGroup.defaultProps = {
  children: null,
  disabled: false,
  label: ''
};

export { NativeSelectOptionGroup as N };
